import { HttpInterceptorFn } from '@angular/common/http';
import { API_BASE_URL } from '../config/api-config';

export const acceptProblemDetailInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(`${API_BASE_URL}`)) return next(req);

  // Decide Accept header only if not present
  let headers = req.headers;
  if (!headers.has('Accept')) {
    headers = (req.responseType === 'text')
      ? headers.set('Accept', 'text/plain, */*')
      : headers.set('Accept', 'application/problem+json, application/json');
  }

  const hasBody = req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH';
  const isForm = req.body instanceof FormData;

  // If it's FormData, DO NOT set Content-Type. Remove if someone set it earlier.
  if (hasBody && isForm) {
    return next(req.clone({ headers: headers.delete('Content-Type') }));
  }

  // Only set JSON Content-Type for JSON-like bodies (not FormData/Blob/ArrayBuffer/string)
  const shouldSetJson =
    hasBody &&
    !headers.has('Content-Type') &&
    !(req.body instanceof Blob) &&
    !(req.body instanceof ArrayBuffer) &&
    typeof req.body !== 'string' &&
    !isForm;

  if (shouldSetJson) {
    return next(req.clone({ headers, setHeaders: { 'Content-Type': 'application/json' } }));
  }

  return next(req.clone({ headers }));
};
